import { IAnalyticsProvider, IViewItemAnalytics, IViewItemAnalyticsItem, IAddToCartAnalytics } from './types';

let provider : IAnalyticsProvider | undefined;

function registerProvider(instance : IAnalyticsProvider) : void {
  if (provider) {
    throw new Error();
  }

  provider = instance;
}

export default {
  registerProvider,
  trackPurchase: (orderData: any) => provider?.trackPurchase(orderData),
  trackViewItem: (viewItemData: IViewItemAnalytics) => provider?.trackViewItem(viewItemData),
  trackAddToCart: (data: IAddToCartAnalytics) => provider?.trackAddToCart(data),
  pushEcommerceItems: (items: IViewItemAnalyticsItem[]) => provider?.pushEcommerceItems(items),
};
